import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_Field = _resolveComponent("Field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_FocusLock = _resolveComponent("FocusLock")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_Form = _resolveComponent("Form")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.visible) = $event)),
    width: "500"
  }, {
    activator: _withCtx(({}) => [
      _createVNode(_component_v_btn, {
        color: "primary",
        onClick: _ctx.open
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('einstellungen.dialog.button')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_Form, null, {
        default: _withCtx(({ meta }) => [
          _createElementVNode("form", {
            onSubmit: _cache[18] || (_cache[18] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
          }, [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_FocusLock, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, { class: "headline font-weight-bold mb-2" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('lieferant.details.title')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_text, { class: "pb-0" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "12" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Field, {
                                  modelValue: _ctx.formDataCopy.mwstNummer,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formDataCopy.mwstNummer) = $event)),
                                  label: _ctx.$t('lieferant.details.mwstNummer'),
                                  name: "mwstNummer",
                                  rules: _ctx.getValidation('lieferantStammdatenApiDto.mwstNummer') + '|starts_with:CHE'
                                }, {
                                  default: _withCtx(({ errors, field }) => [
                                    _createVNode(_component_v_text_field, _mergeProps(field, {
                                      modelValue: _ctx.formDataCopy.mwstNummer,
                                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formDataCopy.mwstNummer) = $event)),
                                      autofocus: "",
                                      label: _ctx.$t('lieferant.details.mwstNummer') + ' *',
                                      placeholder: "CHE-...",
                                      variant: "outlined",
                                      density: "comfortable",
                                      "error-messages": errors
                                    }), null, 16, ["modelValue", "label", "error-messages"])
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "label", "rules"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, { cols: "12" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Field, {
                                  modelValue: _ctx.formDataCopy.firma,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formDataCopy.firma) = $event)),
                                  label: _ctx.$t('lieferant.details.firmenname'),
                                  name: "firmenname",
                                  rules: _ctx.getValidation('lieferantStammdatenApiDto.firma')
                                }, {
                                  default: _withCtx(({ errors, field }) => [
                                    _createVNode(_component_v_text_field, _mergeProps(field, {
                                      modelValue: _ctx.formDataCopy.firma,
                                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formDataCopy.firma) = $event)),
                                      label: _ctx.$t('lieferant.details.firmenname') + ' *',
                                      variant: "outlined",
                                      density: "comfortable",
                                      "error-messages": errors
                                    }), null, 16, ["modelValue", "label", "error-messages"])
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "label", "rules"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "12" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Field, {
                                  modelValue: _ctx.formDataCopy.adresszeile1,
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formDataCopy.adresszeile1) = $event)),
                                  label: _ctx.$t('lieferant.details.adresszeile1'),
                                  name: "adresszeile1",
                                  rules: _ctx.getValidation('lieferantStammdatenApiDto.adresszeile1')
                                }, {
                                  default: _withCtx(({ errors, field }) => [
                                    _createVNode(_component_v_text_field, _mergeProps(field, {
                                      modelValue: _ctx.formDataCopy.adresszeile1,
                                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formDataCopy.adresszeile1) = $event)),
                                      label: _ctx.$t('lieferant.details.adresszeile1') + ' *',
                                      variant: "outlined",
                                      density: "comfortable",
                                      "error-messages": errors
                                    }), null, 16, ["modelValue", "label", "error-messages"])
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "label", "rules"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, { cols: "12" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Field, {
                                  modelValue: _ctx.formDataCopy.adresszeile2,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formDataCopy.adresszeile2) = $event)),
                                  label: _ctx.$t('lieferant.details.adresszeile2'),
                                  rules: _ctx.getValidation('lieferantStammdatenApiDto.adresszeile2'),
                                  name: "adresszeile2"
                                }, {
                                  default: _withCtx(({ errors, field }) => [
                                    _createVNode(_component_v_text_field, _mergeProps(field, {
                                      modelValue: _ctx.formDataCopy.adresszeile2,
                                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formDataCopy.adresszeile2) = $event)),
                                      label: _ctx.$t('lieferant.details.adresszeile2'),
                                      variant: "outlined",
                                      density: "comfortable",
                                      "error-messages": errors
                                    }), null, 16, ["modelValue", "label", "error-messages"])
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "label", "rules"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "12" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Field, {
                                  modelValue: _ctx.formDataCopy.adresszeile3,
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formDataCopy.adresszeile3) = $event)),
                                  label: _ctx.$t('lieferant.details.adresszeile3'),
                                  rules: _ctx.getValidation('lieferantStammdatenApiDto.adresszeile3'),
                                  name: "adresszeile3"
                                }, {
                                  default: _withCtx(({ errors, field }) => [
                                    _createVNode(_component_v_text_field, _mergeProps(field, {
                                      modelValue: _ctx.formDataCopy.adresszeile3,
                                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formDataCopy.adresszeile3) = $event)),
                                      label: _ctx.$t('lieferant.details.adresszeile3'),
                                      variant: "outlined",
                                      density: "comfortable",
                                      "error-messages": errors
                                    }), null, 16, ["modelValue", "label", "error-messages"])
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "label", "rules"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, { cols: "12" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Field, {
                                  modelValue: _ctx.formDataCopy.plz,
                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formDataCopy.plz) = $event)),
                                  label: _ctx.$t('lieferant.details.plz'),
                                  rules: _ctx.getValidation('lieferantStammdatenApiDto.plz'),
                                  name: "plz"
                                }, {
                                  default: _withCtx(({ errors, field }) => [
                                    _createVNode(_component_v_text_field, _mergeProps(field, {
                                      modelValue: _ctx.formDataCopy.plz,
                                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formDataCopy.plz) = $event)),
                                      label: _ctx.$t('lieferant.details.plz') + ' *',
                                      variant: "outlined",
                                      density: "comfortable",
                                      inputmode: "numeric",
                                      type: "text",
                                      "error-messages": errors,
                                      onInput: _cache[11] || (_cache[11] = ($event: any) => (_ctx.formDataCopy.plz = ($event.target as HTMLInputElement).value.replace(/\D/g, '')))
                                    }), null, 16, ["modelValue", "label", "error-messages"])
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "label", "rules"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "12" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Field, {
                                  modelValue: _ctx.formDataCopy.ort,
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formDataCopy.ort) = $event)),
                                  label: _ctx.$t('lieferant.details.ort'),
                                  rules: _ctx.getValidation('lieferantStammdatenApiDto.ort'),
                                  name: "ort"
                                }, {
                                  default: _withCtx(({ errors, field }) => [
                                    _createVNode(_component_v_text_field, _mergeProps(field, {
                                      modelValue: _ctx.formDataCopy.ort,
                                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formDataCopy.ort) = $event)),
                                      label: _ctx.$t('lieferant.details.ort') + ' *',
                                      variant: "outlined",
                                      density: "comfortable",
                                      "error-messages": errors
                                    }), null, 16, ["modelValue", "label", "error-messages"])
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "label", "rules"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, { cols: "12" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Field, {
                                  modelValue: _ctx.formDataCopy.land,
                                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formDataCopy.land) = $event)),
                                  label: _ctx.$t('lieferant.details.land'),
                                  name: "land",
                                  rules: _ctx.getValidation('lieferantStammdatenApiDto.land')
                                }, {
                                  default: _withCtx(({ errors, field }) => [
                                    _createVNode(_component_v_select, _mergeProps(field, {
                                      modelValue: _ctx.formDataCopy.land,
                                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formDataCopy.land) = $event)),
                                      items: _ctx.countryOptions,
                                      "item-title": "title",
                                      "item-value": "value",
                                      label: _ctx.$t('lieferant.details.land') + ' *',
                                      variant: "outlined",
                                      density: "comfortable",
                                      "error-messages": errors
                                    }), null, 16, ["modelValue", "items", "label", "error-messages"])
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "label", "rules"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_actions, { class: "ml-4" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          disabled: !meta.valid,
                          color: "primary",
                          type: "submit",
                          variant: "flat",
                          class: "modalbutton mb-3"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('components.dialog.save')), 1)
                          ]),
                          _: 2
                        }, 1032, ["disabled"]),
                        _createVNode(_component_v_btn, {
                          class: "modalbutton mb-3",
                          variant: "flat",
                          onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.visible = false))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('components.dialog.cancel')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          ], 32)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}